import { translate } from '../../../../../../utils';
import { HeadCell } from '../../../../../../ui-kit';
import { PendingListItemFormValue } from '../../types';

export const connectCardsTableHeadCells: HeadCell<PendingListItemFormValue & { actions: unknown }>[] = [
    { id: 'description', label: translate('Warehouse card') },
    { id: 'quantity', label: translate('Amount') },
    { id: 'unitPriceWithoutVat', label: translate('Price') },
    { id: 'unitPrice', label: translate('Price + VAT') },
    { id: 'stockCard', label: translate('Attached to') },
    { id: 'finalAmount', label: translate('Final amount') },
    { id: 'unitOfMeasure', label: translate('Unit') },
    { id: 'actions', label: translate('Actions') },
];
